export default "__VITE_ASSET__A0z6fQWm__"